import React from "react";
import ScrollUpButton from "react-scroll-up-button";

export const ToTopButton = () => (
  <div>
    <ScrollUpButton ShowAtPosition={20} />
  </div>
);
